var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_21760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_21760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7753 17.0831H6.00926V7.08309L11.5382 1.58643L12.2432 2.29143C12.3297 2.37795 12.4016 2.49254 12.4588 2.63518C12.5159 2.77782 12.5445 2.91219 12.5445 3.0383V3.24976L11.6599 7.08309H17.2432C17.6396 7.08309 17.9897 7.23511 18.2936 7.53913C18.5977 7.84302 18.7497 8.19316 18.7497 8.58955V9.93559C18.7497 10.0221 18.7384 10.1156 18.7159 10.216C18.6936 10.3164 18.6685 10.41 18.6407 10.4966L16.2528 16.1312C16.1332 16.3983 15.9329 16.6237 15.652 16.8075C15.371 16.9912 15.0788 17.0831 14.7753 17.0831ZM7.25926 15.8331H14.7753C14.834 15.8331 14.8941 15.8171 14.9555 15.785C15.017 15.7529 15.0638 15.6995 15.0959 15.6248L17.4997 9.99976V8.58955C17.4997 8.51469 17.4756 8.45323 17.4276 8.40518C17.3795 8.35712 17.3181 8.33309 17.2432 8.33309H10.0799L11.1247 3.7658L7.25926 7.61518V15.8331ZM6.00926 7.08309V8.33309H3.33301V15.8331H6.00926V17.0831H2.08301V7.08309H6.00926Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.7353bd0bb9ba4a7d49ffd09822639d7f.svg";
export { ForwardRef as ReactComponent };